// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__g0Ha3","col":"styles_col__3OZ-j","fulfillmentStatus":"styles_fulfillmentStatus__2Z2gI","emailCol":"styles_emailCol__Z2o8j"};